"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_CLASSES = exports.CONTAINER_CLASSES = exports.AppendedInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _classnames = _interopRequireDefault(require("classnames"));
var _reactAriaComponents = require("react-aria-components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CONTAINER_CLASSES = exports.CONTAINER_CLASSES = "flex flex-row w-full bg-base-200 rounded-xl overflow-hidden border border-transparent focus-within:border-primary h-12";
var INPUT_CLASSES = exports.INPUT_CLASSES = "peer bg-base-200 px-4 rounded-l-xl outline-none w-full disabled:opacity-50 disabled:cursor-not-allowed";
var AppendedInput = exports.AppendedInput = function AppendedInput(_ref) {
  var id = _ref.id,
    type = _ref.type,
    Icon = _ref.icon,
    label = _ref.label,
    placeholder = _ref.placeholder,
    registeredField = _ref.registeredField,
    disabled = _ref.disabled,
    defaultValue = _ref.defaultValue,
    simple = _ref.simple,
    _ref$valueAlign = _ref.valueAlign,
    valueAlign = _ref$valueAlign === void 0 ? "left" : _ref$valueAlign,
    testId = _ref.testId,
    value = _ref.value,
    onBlur = _ref.onBlur,
    onIconClick = _ref.onIconClick,
    maxLength = _ref.maxLength,
    autoComplete = _ref.autoComplete,
    wrapperClassName = _ref.wrapperClassName,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? "text-md text-neutral-content" : _ref$inputClassName;
  var handleBlur = (0, _react.useCallback)(function (e) {
    if (onBlur) {
      onBlur(e);
    } else if (registeredField !== null && registeredField !== void 0 && registeredField.onBlur) {
      registeredField.onBlur(e);
    }
  }, [registeredField, onBlur]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames["default"])(CONTAINER_CLASSES, _defineProperty({}, "".concat(wrapperClassName), wrapperClassName)),
    "aria-label": placeholder || id,
    "data-testid": testId,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactAriaComponents.Input, {
      id: id,
      type: type,
      placeholder: placeholder,
      ref: registeredField === null || registeredField === void 0 ? void 0 : registeredField.ref,
      name: registeredField === null || registeredField === void 0 ? void 0 : registeredField.name,
      onChange: registeredField === null || registeredField === void 0 ? void 0 : registeredField.onChange,
      onBlur: handleBlur,
      value: value,
      maxLength: maxLength,
      autoComplete: autoComplete,
      disabled: disabled,
      defaultValue: defaultValue,
      className: (0, _classnames["default"])(INPUT_CLASSES, "text-".concat(valueAlign), _defineProperty(_defineProperty({}, "".concat(inputClassName), inputClassName), "pr-0", simple)),
      readOnly: !(registeredField !== null && registeredField !== void 0 && registeredField.onChange)
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      role: "contentinfo",
      className: (0, _classnames["default"])("bg-primary gap-1 py-3 px-4 flex flex-row items-center rounded-xl", {
        "!bg-transparent flex-row-reverse text-black": simple,
        "cursor-pointer": !!onIconClick
      }),
      onClick: function onClick(e) {
        return onIconClick === null || onIconClick === void 0 ? void 0 : onIconClick(e);
      },
      children: [Icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {
        color: "currentFill",
        className: (0, _classnames["default"])("w-6 h-6", {
          "!fill-neutral-content": simple,
          "!fill-primary-content": !simple
        })
      }), label && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _classnames["default"])({
          "text-neutral-content": simple,
          "text-primary-content": !simple
        }),
        children: label
      })]
    })]
  });
};